import React from 'react'
import {Row, Col} from 'react-flexbox-grid'

import {Alert, Button} from 'antd'

import {NetworkService} from 'api/network'

export class AccessDenied extends React.Component {
   static get propTypes() {
      return {
         nid: React.PropTypes.string.isRequired
      }
   }
   constructor() {
      super()

      this.state = {
         loading: null,
         error:   null
      }

      this.reloadNetwork = this.reloadNetwork.bind(this)
   }

   componentDidMount() {
      this._mounted = true
   }

   componentWillUnmount() {
      this._mounted = false
   }

   reloadNetwork() {
      const {nid} = this.props

      this.setState({loading: true})

      NetworkService.fetch(nid)
         .catch(_err => {
            console.log('_err', _err, _err.req)
            if (this._mounted) {
               this.setState({error: 'some error', loading: false})
            }
         })
         .then(_resp => {
            if (this._mounted) {
               this.setState({loading: false})
            }
         })
   }

   render() {
      const {loading, error} = this.state
      let suffix = ''

      if (true === loading) {
         suffix = ' (loading...)'
      } else if (false === loading) {
         suffix = ' (reloaded)'
      }

      console.log('render', 'dashboard/network/AccessDenied', window.location.hash)

      return (
         <Row>
            <Col xs={12}>
               <Alert
                  type="error"
                  showIcon
                  message={'Access Denied' + suffix}
                  description={
                     <div>
                        <p>
                           You don't have access rights to this network. If you've recently
                           changed Access Policies you can try to reload the network
                        </p>

                        {error ? <p>{error}</p> : null}

                        <p>
                           <Button loading={loading} onClick={this.reloadNetwork} icon="reload">
                              Reload the network
                           </Button>
                        </p>
                     </div>
                  }
               />
            </Col>
         </Row>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/AccessDenied.jsx